import { z } from 'zod';

export const AcceptTermsResultSchema = z.object({
  code: z.number(),
  message: z.string(),
});

export type AcceptTermsResult = z.infer<typeof AcceptTermsResultSchema>;

export interface AcceptTermsParams {
  accept: boolean;
  currency: string;
}
